module.exports = __webpack_public_path__ + "static/media/file-exclamation.2153224f.svg";